import React, { useEffect, useState } from 'react';
import { Popover } from '@mui/material';
import { FindSuccessItem } from 'utils';

export const ManageActions = ({
    actionType,
    headerTitle,
    btnIcon,
    btnTitle,
    renderBtnView,
    btnClass,
    renderBody,
    disabled,
    anchorOrigin,
    transformOrigin,
    styleBodyItems,
    wrapperStyles,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const openPopper = Boolean(anchorEl);
    const id = openPopper ? 'simple-popover' : undefined;
    const success = FindSuccessItem(actionType);

    useEffect(() => {
        if (success && anchorEl) {
            setAnchorEl(null);
        }
    }, [success]);

    const handleClick = (event) => {
        event?.preventDefault();
        event?.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event?.stopPropagation();
        setAnchorEl(null);
    };

    return (
        <div style={wrapperStyles ? wrapperStyles : {}}>
            <button disabled={disabled} aria-describedby={id} className={btnClass} onClick={handleClick}>
                {renderBtnView ? (
                    renderBtnView?.(anchorEl)
                ) : (
                    <>
                        {btnIcon && <img src={btnIcon} alt="icon" />}
                        {btnTitle && <p className="action-bnt-title">{btnTitle}</p>}
                    </>
                )}
            </button>

            {/*<Popover*/}
            {/*    id={id}*/}
            {/*    open={openPopper}*/}
            {/*    anchorEl={anchorEl}*/}
            {/*    onClose={handleClose}*/}
            {/*    anchorOrigin={{*/}
            {/*        vertical: 'bottom',*/}
            {/*        horizontal: 'right',*/}
            {/*    }}*/}
            {/*    transformOrigin={{*/}
            {/*        vertical: 'bottom',*/}
            {/*        horizontal: 'right',*/}
            {/*    }}*/}
            {/*    PaperProps={{*/}
            {/*        sx: {*/}
            {/*            minWidth: 150,*/}
            {/*            borderRadius: '8px',*/}
            {/*        },*/}
            {/*    }}*/}
            {/*>*/}

            <Popover
                id={id}
                open={openPopper}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                PaperProps={{
                    sx: { minWidth: 150, borderRadius: '8px' },
                }}
                PopperProps={{
                    modifiers: [
                        {
                            name: 'flip',
                            enabled: false,
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                padding: 8,
                            },
                        },
                    ],
                }}
            >
                <div className="manage-actions-popover">
                    {headerTitle && <div className="manage-actions-popover-header">{headerTitle}</div>}
                    <div className="manage-actions-popover-body" style={styleBodyItems}>
                        {renderBody(handleClose)}
                    </div>
                </div>
            </Popover>
        </div>
    );
};
